import { plainToClass } from 'class-transformer'
import { validate } from 'class-validator'
import { store } from '../../store'
import { ListDefaultExperiencePointsDTO } from '../../dto/gamification'

export const listDefaultExperiencePoints = async () => {

    let body, response

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/cms/default-experience-points`, {
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'get'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'LIST_DEFAULT_EXPERIENCE_POINTS_TIMEOUT' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'LIST_DEFAULT_EXPERIENCE_POINTS_UNAUTHORIZED' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'LIST_DEFAULT_EXPERIENCE_POINTS_UNEXPECTEDRESPONSE' } )
        return

    }

    try {

        body = plainToClass( ListDefaultExperiencePointsDTO, JSON.parse( await response.text() ) )

    } catch ( exception ) {

        store.dispatch( { type: 'LIST_DEFAULT_EXPERIENCE_POINTS_INVALIDJSON' } )
        return

    }

    if ( ( await validate( body ) ).length > 0 ) {

        store.dispatch( { type: 'LIST_DEFAULT_EXPERIENCE_POINTS_INVALIDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'LIST_DEFAULT_EXPERIENCE_POINTS_OK', defaultExperiencePoints: body.defaultExperiencePoints } )

}
